import React from 'react'
import placeholder from 'images/placeholders/chart.png'

export default function LimitedViewChart() {
  return (
    <React.Fragment>
      <div aria-label="Purchase to discover!" className="tooltip-flirt" data-balloon-pos="up" data-balloon-visible>
        <img alt="" src={placeholder} />
      </div>
    </React.Fragment>
  )
}
